import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { ModulesFacade } from '@library/store/modules/modules.facade';
import { filter, firstValueFrom } from 'rxjs';
import { LayersService } from 'src/app/services/layers.service';
import { UserDataService } from 'src/app/services/user-data.service';

@Component({
  selector: 'app-friends-layer',
  imports: [],
  templateUrl: './friends-layer.component.html',
  styleUrl: './friends-layer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FriendsLayerComponent implements OnInit {
  private readonly modulesFacade = inject(ModulesFacade);
  private readonly userDataService = inject(UserDataService);
  private readonly layersService = inject(LayersService);

  async ngOnInit(): Promise<void> {
    await firstValueFrom(this.userDataService.loaded$.pipe(filter((loaded) => !!loaded)));

    const modules = await firstValueFrom(this.modulesFacade.modules$.pipe(filter((modules) => modules.length > 0)));
    const friendStations = modules.filter((module) => module.mode === 'friend' && module.type === 'NAMain');

    this.layersService.setGeoJSONData('friend-stations', friendStations, modules);
  }
}
